import React, { useState } from "react";
import { message, Modal } from "antd";
import moment from "moment";
import mixpanel from "mixpanel-browser";
import { mixPanelToken, isStage } from "../../../../config";
import less from "./customerSeats.module.scss";
const CustomerSeats = props => {
  const {
    seats,
    mealOptions,
    cutoffTime,
    canSelectDinner,
    showDinnerButton,
    showAmenityButton,
    amenities,
    isOnboarded,
    busDetails,
    booking
  } = props;
  let foodOptions = [],
    defaultFoodOptionName = null;

  if (
    mealOptions &&
    mealOptions.foodOptions &&
    mealOptions.foodOptions.length > 0
  ) {
    foodOptions = mealOptions.foodOptions;
    const defaultFoodOptionId = mealOptions.defaultFoodOptionId;
    const defaultFoodOption = mealOptions.foodOptions.find(
      obj => obj._id == defaultFoodOptionId
    );
    defaultFoodOptionName = defaultFoodOption ? defaultFoodOption.name : null;
  }
  const [amenitiesOptions, setAmenitiesOptions] = useState(
    amenities ? amenities.amenities : []
  );
  const [showDinner, setDinnerVisibility] = useState(false);
  const [showDinnerFor, setDinnerForVisibility] = useState({});
  const [dinnerSelected, setDinnerSelected] = useState(null);
  const [dinnerSuccess, setDinnerSuccessModal] = useState(false);
  const [amenitiesSuccess, setAmenitiesSuccessModal] = useState(false);
  const [showCancelAmenity, setCancelModal] = useState(false);
  const [onboardedAmenityRequest, setRequestAfterBoadringVisibility] = useState(
    false
  );
  const [seatNumber, setSeatNumber] = useState("");
  const [showAmenities, setAmenitiesVisibility] = useState(false);
  const [showRequestedAmenities, setRequestedAmenitiesVisibility] = useState(
    false
  );

  const [showAmenitiesFor, setAmenitiesForVisibility] = useState({});
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [cancelledAmenity, selectedCancelledAmenity] = useState({});

  const toggleAmenity = amenity => {
    if (selectedAmenities.includes(amenity._id)) {
      setSelectedAmenities(selectedAmenities.filter(id => id !== amenity._id));
    } else {
      setSelectedAmenities([...selectedAmenities, amenity._id]);
    }
    const eventName = "amenity_selected";
    const eventBody = {
      pnr: booking.bookingCode,
      amenity_name: amenity.displayName,
      amenity_type: amenity.type,
      bus_rc: busDetails,
      trip_id: booking.tripId,
      mobile_no: booking.mobileNo,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      service_name: booking.trip.service.name,
      demand_source: booking.demandSource,
      passenger_seat_no: seatNumber,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD")
    };

    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track(eventName, eventBody);
  };

  const handleSelectAll = () => {
    if (selectedAmenities.length === amenitiesOptions.length) {
      setSelectedAmenities([]);
    } else {
      setSelectedAmenities(amenitiesOptions.map(obj => obj._id));
      const eventName = "amenity_selected";
      const eventBody = {
        pnr: booking.bookingCode,
        amenity_name: amenitiesOptions.map(obj => obj.displayName).join(","),
        amenity_type: amenitiesOptions.map(obj => obj.type).join(","),
        bus_rc: busDetails,
        trip_id: booking.tripId,
        mobile_no: booking.mobileNo,
        from_city: booking.boardingPoint.city,
        passenger_seat_no: seatNumber,
        to_city: booking.dropPoint.city,
        service_name: booking.trip.service.name,
        demand_source: booking.demandSource,
        trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD")
      };
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track(eventName, eventBody);
    }
  };

  const dinnerForVisibility = obj => {
    setDinnerForVisibility(obj);

    setDinnerVisibility(true);
  };

  const amenitiesForVisibility = obj => {
    setAmenitiesOptions(amenities.amenities || []);
    setAmenitiesForVisibility(obj);
    if (obj.requestedAmenity.length > 0) {
      setRequestedAmenitiesVisibility(true);
    } else if (isOnboarded && !amenities.onboardRequestsAllowed) {
      setRequestAfterBoadringVisibility(true);
    } else {
      setAmenitiesVisibility(true);
    }
    setSeatNumber(obj.seatLabel);
    let eventName = "add_amenities_clicked";
    let eventBody = {
      pnr: booking.bookingCode,
      passenger_seat_no: obj.seatLabel,
      bus_rc: busDetails,
      trip_id: booking.tripId,
      mobile_no: booking.mobileNo,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      service_name: booking.trip.service.name,
      demand_source: booking.demandSource,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD")
    };

    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track(eventName, eventBody);
  };

  const requestMoreAmenities = obj => {
    const updatedAmenities = amenitiesOptions.filter(
      amenity => !obj.requestedAmenity.map(a => a._id).includes(amenity._id)
    );
    setAmenitiesOptions(updatedAmenities);
    setRequestedAmenitiesVisibility(false);
    setAmenitiesVisibility(true);
  };

  const cancelModal = value => {
    setRequestedAmenitiesVisibility(false);
    selectedCancelledAmenity(value);
    setCancelModal(true);
  };

  const cancelAmenity = async () => {
    try {
      let amenityId = cancelledAmenity.requestId;
      if (!amenityId) {
        message.error("Something went wrong. Please try again later");
        return;
      }
      const response = await props.cancelAmenity(amenityId);
      setAmenitiesVisibility(false);
      if (response === "success") {
        setAmenitiesSuccessModal(true);
      }
      setCancelModal(false);
      selectedCancelledAmenity({});
    } catch (error) {
      console.log(error);
    }
  };

  const dinnerSave = async mealId => {
    try {
      if (!mealId) {
        message.error("Please select a dinner option");
        return;
      }
      let isFoodOptionSkipped, foodSelected;
      if (mealId == "skip") {
        isFoodOptionSkipped = true;
      } else {
        foodSelected = foodOptions
          .filter(obj => obj._id === mealId)
          .map(obj => {
            return {
              foodOptionId: obj._id,
              foodName: obj.name,
              isVeg: obj.veg
            };
          })[0];
      }

      const response = await props.updateDinner(
        foodSelected,
        showDinnerFor.id,
        isFoodOptionSkipped
      );
      setDinnerVisibility(false);

      if (response === "success") {
        setDinnerSuccessModal(true);
      }

      setDinnerForVisibility({});
      setDinnerSelected(null);
    } catch (error) {
      console.log(error);
    }
  };

  const updateAmenities = async (amenityIds, seatChart, booking) => {
    try {
      const selectedAmenities = amenitiesOptions.filter(am =>
        amenityIds.includes(am._id)
      );
      const amenityNames = selectedAmenities
        .map(obj => obj.displayName)
        .join(",");
      const amenityTypes = selectedAmenities.map(obj => obj.type).join(",");
      const eventName = "amenities_ordered";
      const eventBody = {
        pnr: booking.bookingCode,
        passenger_seat_no: seatNumber,
        amenity_name: amenityNames,
        amenity_type: amenityTypes,
        bus_rc: busDetails,
        trip_id: booking.tripId,
        mobile_no: booking.mobileNo,
        from_city: booking.boardingPoint.city,
        to_city: booking.dropPoint.city,
        service_name: booking.trip.service.name,
        demand_source: booking.demandSource,
        trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD")
      };
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track(eventName, eventBody);
      setAmenitiesVisibility(false);
      const response = await props.updateAmenities(
        amenityIds,
        seatChart.seatId
      );

      if (response === "success") {
        setAmenitiesSuccessModal(true);
      }
      // setRequestedAmenitiesVisibility(false);

      setAmenitiesForVisibility({});
      setSelectedAmenities([]);
    } catch (error) {
      console.log(error);
    }
  };

  const updateDinnerVisibility = () => {
    setDinnerVisibility(false);
    setDinnerForVisibility({});
    setDinnerSelected(null);
  };

  return (
    <div className={less.wrapper}>
      <p>Passenger Details</p>
      {showAmenityButton ? (
        <div className={less.amenitiesBanner}>
          <div>
            <span>Order Free Amenities</span>
            <span>
              Get eye masks, neck pillows, and other travel essentials directly
              through the app now.
            </span>
          </div>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/amenities.svg"
            alt="amenities"
          />
        </div>
      ) : null}

      <div className={less.seats}>
        {seats.map((obj, index) => {
          const showAmenityAction = showAmenityButton;
          const showDinnerAction = showDinnerButton && foodOptions.length > 0;
          const hasDinner = obj.foodSelected && !obj.isFoodOptionSkipped;

          return (
            <div key={index} className={less.seatCard}>
              <div className={less.seatInfo}>
                <div className={less.seatLabel}>
                  <span>{obj.seatLabel}</span>
                </div>
                <span className={less.passengerName}>{obj.name}</span>
                {hasDinner ? (
                  <div className={less.dinnerRequested}>
                    <span>{obj.foodSelected.foodName}</span>
                    <img
                      src={
                        obj.foodSelected.isVeg
                          ? "https://d1flzashw70bti.cloudfront.net/next-gen/images/selfHelp/vegSymbol.webp"
                          : "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/nonveg.svg"
                      }
                      alt={obj.foodSelected.isVeg ? "Veg" : "Non Veg"}
                    />
                  </div>
                ) : null}
              </div>

              {obj.requestedAmenity && obj.requestedAmenity.length > 0 ? (
                <div className={less.amenitiesRequested}>
                  {obj.requestedAmenity.map((obj, index) => (
                    <div
                      key={index}
                      className={
                        obj.type == "RETURNABLE" ? less.returnable : undefined
                      }
                    >
                      <span>{obj.displayName}</span>
                      {obj.type == "RETURNABLE" ? (
                        <img
                          src={
                            "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/amenities/return.svg"
                          }
                          alt={obj.typeof}
                        />
                      ) : null}
                    </div>
                  ))}
                </div>
              ) : null}

              {showAmenityAction || showDinnerAction ? (
                <>
                  <div className={less.divider} />
                  <div className={less.actions}>
                    {showAmenityAction ? (
                      <button
                        onClick={() => amenitiesForVisibility(obj, booking)}
                      >
                        {obj &&
                        obj.requestedAmenity &&
                        obj.requestedAmenity.length > 0
                          ? "Amenities Details"
                          : "Add Amenities"}
                      </button>
                    ) : null}
                    {showDinnerAction ? (
                      <button onClick={() => dinnerForVisibility(obj, booking)}>
                        {canSelectDinner ? "Choose Dinner" : "Dinner Details"}
                      </button>
                    ) : null}
                  </div>
                </>
              ) : null}
            </div>
          );
        })}
      </div>
      {showAmenityButton ? (
        <div className={less.note}>
          <span>
            <b>Note: </b>Items Marked{" "}
          </span>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/amenities/return.svg"
            alt="returnable"
          />
          <span>have to be returned to bus marshal</span>
        </div>
      ) : null}
      {showAmenities ? (
        <Modal
          title="Order Amenities"
          visible={showAmenities}
          onCancel={() => setAmenitiesVisibility(false)}
          footer={null}
        >
          <div className={less.modalDiv}>
            <div className={less.header}>
              <div>
                <span>{showAmenitiesFor.seatLabel}</span>
              </div>
              <span>Select amenities for {showAmenitiesFor.name}</span>
            </div>
            <div className={less.subHeader}>
              <span>Select amenities for the journey:</span>
              <span
                style={{ cursor: "pointer", color: "blue" }}
                onClick={handleSelectAll}
              >
                {selectedAmenities.length === amenitiesOptions.length
                  ? "Unselect All"
                  : "Select All"}
              </span>
            </div>
            <div className={less.optionsContainer}>
              {amenitiesOptions.map((obj, index) => (
                <div key={index} className={less.optionsCard}>
                  <div>
                    <p>{obj.displayName}</p>
                    <div className={less.amenityType}>
                      {obj.type == "RETURNABLE" ? (
                        <img
                          src={
                            "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/amenities/return.svg"
                          }
                          alt={obj.typeof}
                        />
                      ) : null}

                      <span>
                        {obj.type == "RETURNABLE"
                          ? "Returnable Item"
                          : "Take Home"}
                      </span>
                    </div>
                  </div>
                  <input
                    type="checkbox"
                    name="amenities"
                    checked={selectedAmenities.includes(obj._id)}
                    onChange={() => toggleAmenity(obj)}
                  />
                </div>
              ))}
            </div>

            <span>
              Note: Amenities are subject to availability. The operations team
              can confirm or decline a request. We are grateful for your
              co-operation.
            </span>
            <button
              className={less.saveButton}
              onClick={() =>
                updateAmenities(selectedAmenities, showAmenitiesFor, booking)
              }
              disabled={selectedAmenities.length === 0}
            >
              Order Amenities
            </button>
          </div>
        </Modal>
      ) : null}
      {onboardedAmenityRequest ? (
        <Modal
          header={null}
          visible={onboardedAmenityRequest}
          onCancel={() => setRequestAfterBoadringVisibility(false)}
          footer={null}
          centered={true}
        >
          <div className={less.modalResultDiv}>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/amenities/warning.svg"
              alt="warning"
            />
            <span className={less.heading}>Sorry</span>
            <span className={less.subHeader}>
              Amenities cannot be requested after boarding{" "}
            </span>

            <button
              className={less.exitButton}
              onClick={() => setRequestAfterBoadringVisibility(false)}
            >
              OK
            </button>
          </div>
        </Modal>
      ) : null}
      {showRequestedAmenities ? (
        <Modal
          title="Amenities Details"
          visible={showRequestedAmenities}
          onCancel={() => setRequestedAmenitiesVisibility(false)}
          footer={null}
        >
          <div className={less.modalDiv}>
            <div className={less.header}>
              <div>
                <span>{showAmenitiesFor.seatLabel}</span>
              </div>
              <span> {showAmenitiesFor.name}</span>
            </div>

            {showAmenitiesFor.requestedAmenity.map((obj, index) => (
              <div key={index} className={less.selectedAmenitiesCard}>
                <div>
                  <p>{obj.displayName}</p>
                  <div className={less.amenityStatus}>
                    <div className={less.amenityType}>
                      <img
                        src={
                          obj.status == "PENDING"
                            ? "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/amenities/pending.svg"
                            : obj.status == "UNAVAILABLE"
                            ? "https://d1flzashw70bti.cloudfront.net/original/test/selfHelp/warning.svg"
                            : obj.status == "CANCELLED"
                            ? "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/amenities/unavailable.svg"
                            : obj.status == "LOST"
                            ? "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/amenities/unavailable.svg"
                            : "https://d1flzashw70bti.cloudfront.net/original/images/dinnerSelection/check.svg"
                        }
                        alt={obj.status}
                      />
                      <span>{obj.status}</span>
                    </div>
                    <div className={less.amenityType}>
                      {obj.type == "RETURNABLE" ? (
                        <img
                          src={
                            "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/amenities/return.svg"
                          }
                          alt={obj.typeof}
                        />
                      ) : null}
                      <span>
                        {obj.type == "RETURNABLE"
                          ? "Returnable Item"
                          : "Take Home"}
                      </span>
                    </div>
                  </div>
                </div>
                {obj.status == "PENDING" || obj.status == "CONFIRMED" ? (
                  <button onClick={() => cancelModal(obj)}>Cancel</button>
                ) : null}
              </div>
            ))}

            <span>
              Note: Amenities are subject to availability. The operations team
              can confirm or decline a request. We are grateful for your
              co-operation.
            </span>
            {showAmenitiesFor.timesAmenityRequested < 4 &&
            showAmenitiesFor.requestedAmenity.length !==
              amenitiesOptions.length ? (
              <button
                className={less.saveButton}
                onClick={() => requestMoreAmenities(showAmenitiesFor)}
              >
                Order More Amenities
              </button>
            ) : null}
          </div>
        </Modal>
      ) : null}
      {showDinner ? (
        <Modal
          header={null}
          visible={showDinner}
          onCancel={() => updateDinnerVisibility()}
          footer={null}
          centered={true}
        >
          <div className={less.modalDiv}>
            <span className={less.heading}>
              {canSelectDinner ? "Select Dinner" : "Dinner Details"}
            </span>
            <div className={less.header}>
              <div>
                <span>{showDinnerFor.seatLabel}</span>
              </div>
              {canSelectDinner ? (
                <span>Select dinner for {showDinnerFor.name}</span>
              ) : (
                <span> {showDinnerFor.name}</span>
              )}
            </div>
            {canSelectDinner ? (
              <div className={less.subHeader}>
                <span>Select dinner option for the journey:</span>
              </div>
            ) : null}
            <div className={less.optionsContainer}>
              {foodOptions.map((obj, index) => (
                <div key={index} className={less.optionsCard}>
                  <div>
                    <p>{obj.name}</p>
                    {obj._id === "skip" ? null : (
                      <div>
                        <img
                          src={
                            obj.veg
                              ? "https://d1flzashw70bti.cloudfront.net/next-gen/images/selfHelp/vegSymbol.webp"
                              : "https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/dinner/nonVeg.svg"
                          }
                          alt={obj.veg ? "Veg" : "Non Veg"}
                        />

                        <span>{obj.veg ? "Veg" : "Non Veg"}</span>
                      </div>
                    )}
                  </div>
                  {dinnerSelected ? (
                    <input
                      type="radio"
                      name="meal"
                      checked={dinnerSelected === obj._id}
                      value={obj.name}
                      onChange={() => setDinnerSelected(obj._id)}
                    />
                  ) : canSelectDinner ? (
                    <input
                      type="radio"
                      name="meal"
                      checked={
                        dinnerSelected === obj._id ||
                        (showDinnerFor &&
                          showDinnerFor.foodSelected &&
                          showDinnerFor.foodSelected.foodOptionId ===
                            obj._id) ||
                        (obj._id === "skip" &&
                          showDinnerFor &&
                          showDinnerFor.isFoodOptionSkipped)
                      }
                      value={obj.name}
                      onChange={() => setDinnerSelected(obj._id)}
                    />
                  ) : (showDinnerFor.isFoodOptionSkipped
                      ? null
                      : showDinnerFor.foodSelected &&
                        showDinnerFor.foodSelected.foodOptionId === obj._id) ||
                    (obj._id === "skip" &&
                      showDinnerFor.isFoodOptionSkipped) ? (
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/dinnerSelection/check.svg"
                      alt="success"
                    />
                  ) : null}
                </div>
              ))}
            </div>

            {canSelectDinner ? (
              <span>
                Note: Dinner selection is available until{" "}
                {moment(cutoffTime).format("Do MMM, h:mm a")}
              </span>
            ) : (
              <span>
                Note: Dinner selection has closed. You will receive{" "}
                {showDinnerFor.isFoodOptionSkipped
                  ? "No Meal"
                  : showDinnerFor.foodSelected &&
                    showDinnerFor.foodSelected.foodOptionId
                  ? showDinnerFor.foodSelected.foodName
                  : defaultFoodOptionName}
              </span>
            )}

            {canSelectDinner && dinnerSelected ? (
              <button
                className={less.saveButton}
                onClick={() => dinnerSave(dinnerSelected)}
              >
                Save Dinner
              </button>
            ) : null}
          </div>
        </Modal>
      ) : null}
      <Modal
        cancelButtonProps={{ style: { display: "none" } }}
        visible={dinnerSuccess}
        footer={null}
        onCancel={null}
        closable={false}
        centered={true}
      >
        <div className={less.modalResultDiv}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/dinnerSelection/check.svg"
            alt="success"
          />
          <span className={less.heading}>Dinner Preference Saved</span>
          <span className={less.subHeader}>
            Your preferences have been saved
          </span>
          <button
            className={less.saveButton}
            onClick={() => setDinnerSuccessModal(false)}
          >
            Got it
          </button>
        </div>
      </Modal>
      <Modal
        header={null}
        visible={amenitiesSuccess}
        onCancel={null}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
        footer={null}
        centered={true}
      >
        <div className={less.modalResultDiv}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/dinnerSelection/check.svg"
            alt="success"
          />
          <span className={less.heading}>Amenities Requested Successfully</span>
          <span className={less.subHeader}>
            Your preferences have been saved
          </span>
          <button
            className={less.saveButton}
            onClick={() => setAmenitiesSuccessModal(false)}
          >
            Got it
          </button>
        </div>
      </Modal>
      <Modal
        header={null}
        visible={showCancelAmenity}
        onCancel={() => setCancelModal(false)}
        footer={null}
        centered={true}
      >
        <div className={less.modalResultDiv}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/amenities/warning.svg"
            alt="warning"
          />
          <span className={less.heading}>Are you sure?</span>
          <span className={less.subHeader}>
            Amenities cancellation cannot be undone.{" "}
          </span>
          <button className={less.saveButton} onClick={() => cancelAmenity()}>
            Cancel Amenity
          </button>
          <button
            className={less.exitButton}
            onClick={() => setCancelModal(false)}
          >
            Exit
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default CustomerSeats;
